import { render } from "./CarouselButtons.vue?vue&type=template&id=475b3632&scoped=true"
import script from "./CarouselButtons.vue?vue&type=script&lang=ts"
export * from "./CarouselButtons.vue?vue&type=script&lang=ts"

import "./CarouselButtons.vue?vue&type=style&index=0&id=475b3632&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-475b3632"

export default script